export const getComputedPropertyValue = (node: Element, property: string): string => {
  if (!node) {
    return '';
  }

  const style = getComputedStyle(node);
  if (!style) {
    return '';
  }

  try {
    return style.getPropertyValue(property);
  } catch (error) {
    return '';
  }
};

export const getComputedPropertyValueAsNumber = (node: Element, property: string): number =>
  parseInt(getComputedPropertyValue(node, property), 10) || 0;
